import type { Run } from "./types";

export function remainingAt(seconds: number | undefined, observedAt: string | undefined, now: number, ticking = true): number {
	const value = Math.max(0, Number(seconds || 0));
	if (!ticking || !observedAt) return value;
	const observed = new Date(observedAt).getTime();
	if (!Number.isFinite(observed)) return value;
	return Math.max(0, value - Math.max(0, Math.floor((now - observed) / 1000)));
}

export function programProgress(run: Run, now: number, ticking = true): number {
	const total = Number(run.programTotalSeconds || 0);
	if (total <= 0) return 0;
	const remaining = remainingAt(run.programRemainingSeconds, run.observedAt, now, ticking && !run.paused);
	return Math.min(99, Math.max(0, ((total - remaining) / total) * 100));
}

export function zoneProgress(run: Run, now: number, ticking = true): number {
	const total = Number(run.zoneTotalSeconds || 0);
	if (total <= 0) return 0;
	const remaining = remainingAt(run.remainingSeconds, run.observedAt, now, ticking && !run.paused);
	return Math.min(99, Math.max(0, ((total - remaining) / total) * 100));
}

export function formatCountdown(seconds: number): string {
	const value = Math.max(0, Math.floor(seconds));
	const hours = Math.floor(value / 3600);
	const minutes = Math.floor((value % 3600) / 60);
	const remainder = value % 60;
	return hours > 0
		? `${hours}:${String(minutes).padStart(2, "0")}:${String(remainder).padStart(2, "0")}`
		: `${minutes}:${String(remainder).padStart(2, "0")}`;
}

export function zonePosition(run: Run): string {
	if (!run.currentZoneIndex || !run.totalZones) return "";
	const cycle = (run.totalCycles || 1) > 1 ? ` · Cycle ${run.currentCycle || 1} of ${run.totalCycles}` : "";
	return `Zone ${run.currentZoneIndex} of ${run.totalZones}${cycle}`;
}
